import banner2 from "../assets/banner3.jpg";
import UnifiedServicePage from "./UnifiedServicePage";

export default function SolarHeatingRefrigerationPage() {
  return (
    <UnifiedServicePage
      title="Solar Heating & Refrigeration"
      kicker="Efficient Thermal Energy Systems"
      intro="We deliver solar water heating and refrigeration systems for institutions, businesses, healthcare facilities, schools, and residential clients."
      heroImage={banner2}
      overviewTitle="Sustainable Heating and Cooling"
      overviewText="Our solutions reduce grid dependency while maintaining dependable thermal performance and long-term operational value."
      featureTitle="Service Coverage"
      features={[
        {
          title: "Solar Water Heating",
          desc: "Design and installation of high-efficiency solar heating systems for varied facility sizes.",
        },
        {
          title: "Solar Refrigeration",
          desc: "Renewable-powered refrigeration solutions for health, education, and commercial environments.",
        },
        {
          title: "Hybrid Backup Integration",
          desc: "Battery and auxiliary backup options for uninterrupted performance.",
        },
        {
          title: "Commercial Installations",
          desc: "Project delivery for institutions, offices, hospitality, and industrial use cases.",
        },
        {
          title: "Residential Systems",
          desc: "Compact and durable home systems built for efficient daily usage.",
        },
        {
          title: "Maintenance Services",
          desc: "Planned maintenance and responsive support to preserve system reliability.",
        },
      ]}
      focusTitle="How We Deliver"
      focusItems={[
        {
          title: "Requirement Analysis",
          desc: "Usage profiling and system sizing based on thermal demand.",
        },
        {
          title: "System Design",
          desc: "Customized technical design with energy-efficiency considerations.",
        },
        {
          title: "Installation & Testing",
          desc: "Deployment with safety checks, quality assurance, and handover training.",
        },
        {
          title: "Ongoing Support",
          desc: "After-sales maintenance and optimization for peak performance.",
        },
      ]}
      testimonyQuote="Working with DOUBLE F  on our solar project was successful from consultation through installation and support."
      testimonyAuthor="Spokesperson, BOA"
    />
  );
}
